import { useEffect, useState } from 'react';

import { useParams } from 'react-router';

import { Card } from '../../../components/base/Card';
import { SectionLoading } from '../../../components/shared/SectionLoading';
import { IFaultDefinition } from '../../../types/Fault/FaultDefinition';
import useSuperAdminFaultDefinitions from '../../../data/fault/superadmin/useSuperAdminFaultDefinitions';
import { CreateEditFaultDefinition } from '../../../components/Fault/CreateEditFaultDefinition';

export default function FaultDefinitionAddEditPage() {
  const { faultDefinitionId } = useParams();
  const { faultDefinitions } = useSuperAdminFaultDefinitions();
  const [faultDefinition, setFaultDefinition] = useState<
    IFaultDefinition | undefined
  >(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (faultDefinitionId) {
      if (!faultDefinitions.isLoading && faultDefinitions.data) {
        setFaultDefinition(
          faultDefinitions.data?.find(
            (definition) => definition.id === faultDefinitionId
          )
        );
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  }, [faultDefinitionId, faultDefinitions.isLoading, faultDefinitions.data]);

  return loading ? (
    <SectionLoading />
  ) : (
    <Card
      title={faultDefinition ? 'Edit Fault Definition' : 'New Fault Definition'}
    >
      <div className="mt-6">
        <CreateEditFaultDefinition faultDefinition={faultDefinition} />
      </div>
    </Card>
  );
}
